import {
    ADD_P24_TRANSACTION,
    FETCH_P24_TRANSACTIONS,
    FETCH_P24_TRANSACTION,
    FILTER_P24_TRANSACTIONS,
    FETCH_P24_TRANSACTION_DATA_BYP24,
    FETCH_P24_TRANSACTION_REFUNDS_DATA_BYP24,
    FETCH_P24_TRANSACTION_REFUNDS,
    REFUND_P24_TRANSACTION
} from "../actions/actionTypes";

import moment from 'moment';

const defaultState = {
    //lista ze wszystkimi transakcjami p24
    p24TransactionList: [],
    p24Transaction: null,
    //dane wybranej transakcji wg P24
    p24TransactionDataByP24: {},
    //dane wybranej transakcji wraz ze zwrotami wg P24
    p24TransactionRefundsDataByP24: [],
    P24TransactionRefund: {},
    //filtr transakcji (zawiera zakres dat 'od' i 'do')
    p24TransactionFilter: {
        startDate : moment().subtract(1, 'months'),
        endDate : moment()
    },
    //zwroty wybranej transakcji
    p24TransactionRefunds: []
};

export default function p24TransactionReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_P24_TRANSACTIONS: {
            return {
                ...state,
                p24TransactionList: action.payload
            };
        }
        case FILTER_P24_TRANSACTIONS: {
            return {
                ...state,
                p24TransactionFilter: action.payload
            };
        }
        case FETCH_P24_TRANSACTION: {
            return {
                ...state,
                p24Transaction: action.payload
            };
        }
        case FETCH_P24_TRANSACTION_DATA_BYP24: {
            return {
                ...state,
                p24TransactionDataByP24: action.payload
            };
        }
        case FETCH_P24_TRANSACTION_REFUNDS_DATA_BYP24: {
            return {
                ...state,
                p24TransactionRefundsDataByP24: action.payload
            };
        }
        case FETCH_P24_TRANSACTION_REFUNDS: {
            return {
                ...state,
                p24TransactionRefunds: action.payload
            };
        }
        case REFUND_P24_TRANSACTION: {
            return {
                ...state,
                P24TransactionRefund: action.payload
            };
        }
        case ADD_P24_TRANSACTION:
            return {
                ...state,
                p24TransactionList: [action.payload, ...state.p24TransactionList]
            };
        default:
            return state;
    }
}